export default __webpack_public_path__ + "static/media/screen_google_calendar_04.ae3769e1.png";